module.exports = __webpack_public_path__ + "static/media/Skitty_gaussian2.610025a6.png";